import { Component, ViewContainerRef } from '@angular/core';

import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { OverlayService } from './overlay.service';


@Component({
    selector: 'fcp-clean-panel',
    template: '<p></p>'
})
export class CleanPanelComponent { }

@Component({
    selector: 'fcp-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent {
    private overlayRef;

    constructor(
        private service: OverlayService,
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef
    ) {
        this.service.open.subscribe(emit => {
            this.open();
        });
        this.service.close.subscribe(emit => {
            this.close();
        });
    }

    open() {
        const config = new OverlayConfig();
        config.hasBackdrop = true;

        this.overlayRef = this.overlay.create(config);
        this.overlayRef.attach(new ComponentPortal(CleanPanelComponent, this.viewContainerRef));
    }

    close() {
      if (this.overlayRef) {
        this.overlayRef.detach();
      }
    }

}
